import { createAction, handleActions } from 'redux-actions'

const setFilters = createAction('SCREENS/SUBCONTRACTOR_SUB_ORDERS/SET_FILTERS')
const setFilter = createAction('SCREENS/SUBCONTRACTOR_SUB_ORDERS/SET_FILTER')
const resetFilters = createAction('SCREENS/SUBCONTRACTOR_SUB_ORDERS/RESET_FILTERS')

const defaultState = {
  date_range: [],
}

const reducer = handleActions(
  {
    [setFilters]: (state, { payload }) => payload,
    [setFilter]: (state, { payload }) => ({ ...state, [payload.field]: payload.value }),
    [resetFilters]: () => defaultState,
  },
  defaultState,
)

export { setFilters, setFilter, resetFilters, reducer }
